/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import Button from "../component/button";
import { Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const UnsavedDependencyWarning = (props) => {
  const t = props.t;
  useEffect(() => {}, []);
  return (
    <Dialog
      disableScrollLock={true}
      maxWidth={"sm"}
      fullWidth={true}
      open={props.open}
      aria-labelledby="delete-dialog-title"
    >
      <DialogTitle id="delete-dialog-title">
        <div style={{ display: "flex" }}>
          <span style={{ display: "inline-flex", width: "95%" }}>
            {/* {t('UNSAVED_DEPENDENCY')} */}
            {t("WARNING")}
          </span>
          <Tooltip title={t("CLOSE")}>
            <IconButton
              onTouchStart={() => props.close(false)}
              onClick={() => props.close(false)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText>{t("UNSAVED_DEPENDENCY_CHANGES")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={(event) => props.close(false)} color="primary">
          {t("GO_BACK")}
        </Button>
        <Button
          className="buttonSecondary"
          onClick={(event) => props.close(true)}
          color="primary"
        >
          {t("DISCARD_CHANGES")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {};
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(UnsavedDependencyWarning));
